
import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import AppContext from './Context/AppContext'
import Store from './Store'
import Routes from './Routes'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/sass/style.scss'
const store = createStore(Store)
export const Version = '0.1';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContext>
        <Routes />
      </AppContext>
    </Provider>
    <ToastContainer position='bottom-center' />
  </React.StrictMode>,
  document.getElementById('root')
)
